import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {
  DownloadableFile,
  HarbourDuesDeclaration,
  HarbourDuesInvoice
} from '@portbase/bezoekschip-service-typescriptmodels';
import {sendQuery} from "../../../../../common/utils";

@Component({
  selector: 'app-harbour-dues-costs',
  templateUrl: './harbour-dues-rotterdam-costs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HarbourDuesCostsRotterdamComponent {
  readonly selectedDeclaration = input.required<HarbourDuesDeclaration>();

  downloadPdf(invoice: HarbourDuesInvoice) {
    sendQuery('com.portbase.bezoekschip.common.api.harbourdues.queries.GetHarbourDuesDeclarationPdfRotterdam', {
      url: invoice.url,
      crn: this.selectedDeclaration().crn,
      type: invoice.invoiceType,
      statementNumber: this.selectedDeclaration().statementNumber,
      invoiceNumber: invoice.invoiceNumber
    }, {caching: false, showSpinner: true}).subscribe((file: DownloadableFile) => {
      const base64 = file.data.replace(/\s/g, '');
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], {type: file.mediaType || 'application/pdf'});
      const blobUrl = URL.createObjectURL(blob);

      // Open in new tab
      const win = window.open(blobUrl, '_blank', 'noopener,noreferrer');
      setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
    });
  }
}

